import React from 'react';
import { Book } from 'lucide-react';

const glossaryTerms = [
  { term: 'ROI', definition: 'Return on Investment - A performance measure used to evaluate the efficiency of an investment.' },
  { term: 'CPA', definition: 'Cost Per Acquisition - The cost associated with acquiring one customer or lead.' },
  { term: 'CTR', definition: 'Click-Through Rate - The ratio of users who click on a specific link to the number of total users who view a page or advertisement.' },
  { term: 'CRO', definition: 'Conversion Rate Optimization - The systematic process of increasing the percentage of website visitors who take a desired action.' },
  { term: 'CLV', definition: 'Customer Lifetime Value - The total worth to a business of a customer over the whole period of their relationship.' },
  { term: 'KPI', definition: 'Key Performance Indicator - A measurable value that demonstrates how effectively a company is achieving key business objectives.' },
];

const Glossary = () => {
  return (
    <section className="mt-16">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
        <Book className="w-6 h-6 mr-2 text-indigo-600" />
        Marketing Glossary
      </h2>
      <div className="bg-white rounded-lg shadow-md p-6">
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
          {glossaryTerms.map((item, index) => (
            <div key={index} className="mb-4">
              <dt className="font-semibold text-indigo-600">{item.term}</dt>
              <dd className="mt-1 text-gray-600">{item.definition}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default Glossary;